<template>
  <CourseStudent />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
const CourseStudent = defineAsyncComponent(
  () => import("@/views/CourseStudent/CourseHome/course-home.vue")
);

export default defineComponent({
  name: "dashboardStd",
  components: { CourseStudent },
});
</script>
